const _env = import.meta.env;

// https://vitejs.dev/guide/env-and-mode.html
// todo disable all logging in 'production' mode
const doNothing = () => {
    // note: console.{info,dir,debug} are disabled. Use {.log|.warn|.error} instead.
}
if (_env.PROD) {
    console.info = doNothing;
    console.dir = doNothing;
    console.debug = doNothing;
    // note: this is tricky because sometimes we need to test logs in browser console, and we don't see anything
    // console.log = doNothing;
    // console.warn = doNothing;
}

/**
 * Generic configuration for APIs & services
 */
export const cfg = {
    protocol: _env.VITE_APP_PROTOCOL,
    request_timeout: 900000, // milliseconds / 1000 = seconds = 15 minutes
    // NodeJS GraphQL API
    api: {
        host: _env.VITE_APP_API_HOST,
        portless: JSON.parse(_env.VITE_APP_API_PORTLESS),
        port: _env.VITE_APP_API_PORT,
        graphql_path: _env.VITE_APP_GQL_PATH,
        rest_paths: {
            root_mls: `mls`, // MLS data
            root_core: `core`, // core misc endpoints (anything that does not fall in a clear group of endpoints)
            core_ev_offices: `ev-offices`, // endpoint to get JSON object of E&V offices & custom labels
            core_print_listing: `print-listing`,
        }
    },
    // media server
    media: {
        root: _env.VITE_APP_MEDIA_HOST,
        path_brokers: _env.VITE_APP_MEDIA_BROKERS,
        path_listings: _env.VITE_APP_MEDIA_LISTINGS,
        subpath_mcgill: "mcgill",
        subpath_ev: "ev",
    },
    // elasticsearch (Enterprise App Search)
    elastic: {
        api_key: _env.VITE_APP_SEARCH_KEY,
        engine: _env.VITE_APP_SEARCH_ENGINE,
        endpoint: _env.VITE_APP_SEARCH_ENDPOINT,
    },
    // WP REST API (not used) -- todo consider using RTK Query for accessing WP REST endpoints
    wp: {
        api_user: _env.VITE_APP_WP_API_USER,
        api_pwd: _env.VITE_APP_WP_API_PWD,
        namespace: "wp/v2", // WordPress namespace
        custom: "ev/v1", // custom namespace (if applicable)
        posts_per_page: 100, // '?per_page=<>' in WP REST API (ideal 100)
        // REST URL endpoints
        routes: {
            do_something: "do-something"
        },
        // query arguments in URL
        qargs: {
            timestamp: "timestamp",
        }
    },
    // HTML DOM data-* attributes for React root element container
    react: {
        // ids of html nodes with corresponding React modules
        ids: {
            private_seller_report: `react_private-seller-report`,
            private_broker_portal: `react_private-broker-portal`,
            public_listing_single: `react_public-listing-single`,
            public_listings: `react_public-listings`,
            public_dev_title_review: `react_public-dev-title-review`,
            public_standalone_search: `react_public-standalone-search`,
            public_project_shuffler: `react_public-project-shuffler`,
            admin_centris_labels: `react_admin-centris-labels`,
            admin_centris_dictionary: `react_admin-centris-dictionary`,
            admin_centris_requests: `react_admin-centris-requests`,
            admin_centris_brokers: `react_admin-centris-brokers`,
            admin_centris_redirects: `react_admin-centris-redirects`,
            admin_centris_reactexts: `react_admin-centris-reactexts`,
            admin_centris_exclusive_property: `react_admin-centris-exclusive-property`,
        },
        // html data-* attributes on React-linked modules
        attributes: {
            rest_nonce: "rest_nonce",
            resturl: "resturl",
            upload: "upload",
            upload_full: "upload_full",
            xtexts: "xtexts",
        },
        grid_view: {
            listings_per_page: 18
        },
        maps_view: {
            // account: tech@evquebec.com (voir BW > 00990.2-maps-api-prod)
            api_key: _env.VITE_APP_GOOGLE_MAP_KEY,
            map_id: _env.VITE_APP_GOOGLE_MAP_ID,
            default_zoom: 6,
            center: {lat: 45.5019, lng: -73.5674}
        },
        search: {
            url_key: "q", // url query string for Elastic search term
        }
    },
    // classes, settings, etc., related to the Elementor portion of the site (when React interacts w/ Elementor)
    elementor: {
        classes: {
            // set display:none for all nodes that have this class
            hide_if_empty: ".hide-listing-empty"
        }
    },
    // https://tailwindcss.com/docs/responsive-design
    screens: {
        xs: 0,
        sm: 640,
        md: 768,
        lg: 1024,
        xl: 1280,
        '2xl': 1536
    }
};
